module.exports = __webpack_public_path__ + "img/tree-decorated.9179ea21.svg";